var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:`date-range-${_vm._uid}`,staticClass:"d-none",attrs:{"size":"40"},domProps:{"value":_vm.dateRange}}),_c('div',{staticStyle:{"width":"100%"},attrs:{"id":`date-range-container-${_vm._uid}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }